import React from 'react'

const CookiesContainer = () => {

  return (
    <div>
      <script id="CookieDeclaration" src="https://consent.cookiebot.com/10cb9818-5deb-4630-a4d2-daa397ec358c/cd.js" type="text/javascript" async></script>
    </div>
  )
}

export default CookiesContainer
